import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import LinearProgress from "@material-ui/core/LinearProgress";
import Icon from "@material-ui/core/Icon";
import DateRange from "@material-ui/icons/DateRange";

import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardFooter from "components/Card/CardFooter.js";
import CardIcon from "components/Card/CardIcon.js";
import GridItem from "components/Grid/GridItem.js";

import { formatCurrency } from "../../utils/formatCurrency";
import { sumProyeccion } from "./charts/dataTransforms";

const useStyles = makeStyles((theme) => ({
  ...dashboardStyle,
  progressBar: {
    height: 10,
    borderRadius: 5,
    marginTop: 4,
    marginBottom: 12,
  },
  projectionLabel: {
    color: "green",
    fontWeight: "bold",
    marginBottom: 0,
  },
}));

const EstadisProyeccionEfe = ({ proyectaEfectivo, proyectaEfectivoMes }) => {
  const classes = useStyles();

  const suma = sumProyeccion(proyectaEfectivo);
  const sumaMes = sumProyeccion(proyectaEfectivoMes);

  // Calculate progress percentage (daily as % of monthly, capped at 100)
  const dailyProgress = sumaMes > 0 ? Math.min((suma / sumaMes) * 100, 100) : 0;
  // Monthly progress bar always at 100% when there's data, 0% when empty
  const monthlyProgress = sumaMes > 0 ? 100 : 0;

  return (
    <GridItem xs={12} sm={6} md={4}>
      <Card>
        <CardHeader color="primary" stats icon>
          <CardIcon color="primary">
            <Icon>attach_money</Icon>
          </CardIcon>
          <br />
          <h3 className={classes.cardTitle}>PROYECCION INGRESOS</h3>
        </CardHeader>
        <CardBody>
          <br />
          <h4 className={classes.projectionLabel}>
            PROYECTADO DEL DIA: {formatCurrency(suma)}
          </h4>
          <LinearProgress
            variant="determinate"
            value={dailyProgress}
            className={classes.progressBar}
          />
          <h4 className={classes.projectionLabel}>
            PROYECTADO DEL MES: {formatCurrency(sumaMes)}
          </h4>
          <LinearProgress
            variant="determinate"
            value={monthlyProgress}
            className={classes.progressBar}
            color="secondary"
          />
        </CardBody>
        <CardFooter stats>
          <div className={classes.stats}>
            <DateRange />
            Entrada del dia
          </div>
        </CardFooter>
      </Card>
    </GridItem>
  );
};

export default EstadisProyeccionEfe;
